import _ from "lodash";
import { Action, handleActions } from "redux-actions";
import { LOADER } from "constants/action-types";

export interface ILoaderState {
    messages: IMessage[];
}

interface IMessage {
    id?: string | null;
    message: string;
}

export const loader = handleActions<ILoaderState, IMessage>(
    {
        [LOADER.SHOW]: (state: ILoaderState, { payload }: Action<IMessage>): ILoaderState => ({
            messages: [getMessage(payload), ...state.messages],
        }),
        [LOADER.HIDE]: (state: ILoaderState, { payload }: Action<IMessage>): ILoaderState => {
            if (payload?.id) {
                return { messages: _.reject(state.messages, { id: payload.id }) };
            } else if (!payload?.message) {
                return { messages: [] };
            }
            const newState = [...state.messages];
            const index = _.findIndex(state.messages, { message: payload.message });
            if (index !== -1) {
                newState.splice(index, 1);
            }
            return {
                messages: newState,
            };
        },
    },
    { messages: [] },
);

const getMessage = (payload: IMessage | string): IMessage =>
    _.defaults(typeof payload === "string" ? { message: payload } : payload, { id: null });
